import React from "react"
import ContractorTimeslotItem from "../create_project/contractor_timeslot_item";
import { withRouter } from "react-router-dom"
import UserAvatar from "./photograher_avatar"
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner-transparent.gif";
import { formatDatetime } from "../../util/date_util";
import debounce from 'debounce'
import { debouncePromise } from "../../util/custom_function_utils"
import ScrollArrows from "../scroll_arrows"

class ContractorCalendar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: new Date(),
      selectedTime: "",
      dates: [],
      month: new Date(),
      currentDay: new Date(),
      confirmModal: false,
      isLargeScreen: true,
      loading: false
    }
    this.handler = this.handler.bind(this)
    // this.applyTime = this.applyTime.bind(this)
    this.addMonth = this.addMonth.bind(this)
    this.subtractMonth = this.subtractMonth.bind(this)
    this.addDays = this.addDays.bind(this)
    this.subtractDays = this.subtractDays.bind(this)
    this.handleTimeSelect = this.handleTimeSelect.bind(this)
    this.updatePredicate = this.updatePredicate.bind(this)
    this.debouceScrollTo = debounce((selector) => this.scrollTo(selector), 200)

    // debouncePromise only cancels a call while it's still waiting out the
    // debounce delay — once it's actually fired (a real fetchTimes request
    // in flight), a later date change can't cancel it, and if that older
    // request's response happens to arrive after the newer one, it would
    // still clear `loading` and let the (now-stale) time slots be clicked.
    // fetchRequestId makes each call's resolution conditional on still being
    // the most recent one, so a late/out-of-order response for an
    // already-superseded date is simply ignored instead of hiding the
    // loading spinner over stale times.
    this.fetchRequestId = 0
    const debouncedFetchTimes = debouncePromise((options) => {
      return this.props.fetchTimes(options);
    }, 500);
    this.debounceFetchTimes = (options) => {
      const requestId = ++this.fetchRequestId
      return new Promise((resolve) => {
        debouncedFetchTimes(options).then(() => {
          if (requestId === this.fetchRequestId) resolve()
        })
      })
    }
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);

    let today_date = new Date()
    today_date.setDate(today_date.getDate() + 1)

    let previous_time_set = false

    let dates = this.getDaysInMonth(today_date)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({
      dates: dates,
      currentDay: firstSelectable,
      selected: firstSelectable,
      selectedTime: previous_time_set ? today_date : "",
      month: today_date,
      loading: true
    })
    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: null,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
    document.body.style.overflow = 'unset';
  }

  scrollTo(selector) {
    const element = document.querySelector(selector)
    if (element) element.scrollIntoView()
  }

  updatePredicate() {
    this.setState({ isLargeScreen: window.innerWidth > 550 });
  }

  addDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      currentDay.setDate(currentDay.getDate() + 10)
    } else {
      currentDay.setDate(currentDay.getDate() + 5)
    }

    if (currentDay.getMonth() !== this.state.currentDay.getMonth()) {
      currentDay.setDate(1)
    }

    let dates = this.getDaysInMonth(currentDay)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  subtractDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      if (currentDay.getDate() < 11 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 10)
      }
    } else {
      if (currentDay.getDate() < 6 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 5)
      }
    }

    let todayDate = new Date()

    todayDate.setDate(todayDate.getDate() + 1)

    if (currentDay < todayDate && !this.props.currentUser.roles.admin) {
      let dates = this.getDaysInMonth(todayDate)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: todayDate, selected: firstSelectable, selectedTime: "", loading: true })
      this.debounceFetchTimes({
        date: firstSelectable,
        contractor_id: this.props.photographer.id,
        service_id: this.props.selectedService,
        street: this.props.street,
        timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
      }).then(() => this.setState({ loading: false }))
    } else {
      let dates = this.getDaysInMonth(currentDay)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "", loading: true })
      this.debounceFetchTimes({
        date: firstSelectable,
        contractor_id: this.props.photographer.id,
        service_id: this.props.selectedService,
        street: this.props.street,
        timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
      }).then(() => this.setState({ loading: false }))
    }
  }

  // applyTime() {
  //   if (this.state.selectedTime !== "") {
  //     if (this.props.updating && !this.state.confirmModal) {
  //       this.setState({ confirmModal: true })
  //       this.debouceScrollTo(".sub-modal-background")
  //     } else {
  //       this.props.setAppointmentTime(this.state.selectedTime, this.props.photographer)
  //       this.props.changeSelected(null, null, true)
  //     }
  //   }
  // }

  addMonth() {
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() + 1, 1)

    let dates = this.getDaysInMonth(date)

    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  subtractMonth() {
    let today_date = new Date()
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth(), 1)

    if (date.getMonth() != today_date.getMonth() || this.props.currentUser?.roles?.admin) {
      date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() - 1, 1)
    }

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)

    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "", loading: true })

    this.debounceFetchTimes({
      date: firstSelectable,
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  getDaysInMonth(date) {
    let month = date.getMonth()
    let year = date.getFullYear()
    let new_date = new Date(year, month, 1)
    let days = []
    while (new_date.getMonth() === month) {
      days.push(new Date(new_date))
      new_date.setDate(new_date.getDate() + 1)
    }
    return days
  }

  getFirstSelectableDate(dates) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return dates.find(d => {
      const normalized = new Date(d)
      normalized.setHours(0, 0, 0, 0)
      return normalized > today
    }) || dates[dates.length - 1]
  }

  changeSelected(index) {
    this.setState({ selected: this.state.dates[index], selectedTime: "", loading: true })
    this.debounceFetchTimes({
      date: this.state.dates[index],
      contractor_id: this.props.photographer.id,
      service_id: this.props.selectedService,
      street: this.props.street,
      timezone: this.props.detected_timezone || this.props.project?.client?.timezone || this.props.client_timezone
    }).then(() => this.setState({ loading: false }))
  }

  handler(newState) {
    this.setState(newState)
  }

  handleTimeSelect(time) {
    if (this.state.selectedTime.toString() === time.toString()) {
      this.setState({ selectedTime: "" })
    } else {
      this.setState({ selectedTime: time })
    }
  }


  render() {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const isAdmin = this.props.currentUser?.roles?.admin

    const isCurrentMonth = this.state.month.getMonth() === today.getMonth() &&
                           this.state.month.getFullYear() === today.getFullYear()

    const mostRecentSunday = new Date(today)
    mostRecentSunday.setDate(today.getDate() - today.getDay())
    mostRecentSunday.setHours(0, 0, 0, 0)

    const firstDate = this.state.dates[0]
    const fillerDays = []

    if (!isCurrentMonth || isAdmin || !firstDate || mostRecentSunday < firstDate) {
      const startDayOfWeek = firstDate ? firstDate.getDay() : 0
      for (let i = startDayOfWeek - 1; i >= 0; i--) {
        const fillerDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), -i)
        fillerDays.push(
          <div className="createProjectDateOptions createProjectDateDisabled" key={`filler-${i}`}>
            <div className="createProjectDate">{fillerDate.getDate()}</div>
            <div className="createProjectDateDay">{fillerDate.toLocaleString('default', { weekday: 'short' })}</div>
          </div>
        )
      }
    }

    let dates = this.state.dates.map((date, index) => {
      if (isCurrentMonth && !isAdmin && firstDate && mostRecentSunday >= firstDate) {
        const normalized = new Date(date)
        normalized.setHours(0, 0, 0, 0)
        if (normalized < mostRecentSunday) return null
      }
      const normalized = new Date(date)
      normalized.setHours(0, 0, 0, 0)
      const isPast = normalized <= today
      const isSelected = this.state.selected?.toString() === date.toString()

      if (isPast) {
        return (
          <div className={`createProjectDateOptions createProjectDateDisabled${isAdmin ? " createProjectDateDisabledAdmin" : ""}`} key={index}
               id={isAdmin && isSelected ? "createProjectDateOptionSelected" : ""}
               onClick={isAdmin ? () => this.changeSelected(index) : undefined}>
            <div className="createProjectDate"
                 id={isAdmin && isSelected ? "createProjectDateSelected" : ""}>{date.getDate()}</div>
            <div className="createProjectDateDay"
                 id={isAdmin && isSelected ? "createProjectDateDaySelected" : ""}>{date.toLocaleString('default', { weekday: 'short' })}</div>
          </div>
        )
      }

      return (
        <div className="createProjectDateOptions" key={index}
             id={isSelected ? "createProjectDateOptionSelected" : ""}
             onClick={() => this.changeSelected(index)}>
          <div className="createProjectDate"
               id={isSelected ? "createProjectDateSelected" : ""}>{date.getDate()}</div>
          <div className="createProjectDateDay"
               id={isSelected ? "createProjectDateDaySelected" : ""}>{date.toLocaleString('default', { weekday: 'short' })}</div>
        </div>
      )
    })

    let selectedTime = this.state.selectedTime


    let time_slots = this.props.times.map(time => {
      return { time: new Date(time.start_time), unavailable: time.unavailable }
    })

    let times = time_slots.map((time_slot, i) =>
      <ContractorTimeslotItem key={i} time={time_slot.time} unavailable={time_slot.unavailable} selected={selectedTime.toString() === time_slot.time.toString()}
        currentUser={this.props.currentUser} detected_timezone={this.props.detected_timezone} client_timezone={this.props.client_timezone} handleTimeSelect={this.handleTimeSelect} changeParentState={this.handler} />
    )

    let photographer = this.props.photographer

    let modal = ""

    if (this.state.confirmModal) {
      modal = <div className="modal-background sub-modal-background" onClick={() => this.setState({ confirmModal: false })}>
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="contractorModalHeading">
              <div className="confirmationModalDescription">Are you sure you want to make this change?</div>
            </div>
            <div className="confirmationTimeSlotsButtons">
              <div onClick={() => this.setState({ confirmModal: false })} className="signupFormPrevious">Cancel</div>
              <div onClick={this.applyTime} className="signupFormNext" id={this.state.selectedTime === "" ? 'disabled' : ''}>Apply</div>
            </div>
          </div>
        </div>
      </div>
    }

    let modalClass = "orderpreviewModal contractorSchedulingModal"

    if (this.props.homepageModal) {
      modalClass = "orderpreviewModal addServiceModalContent"
    }

    if (this.state.loading) {
      times = [<div className="createProjectLogoSpinner">
        <img className="contractorCalendarLogoImageSpinnerGif" src={LogoSpinner}></img>
      </div>]
    }

    const scrollWrapperStyle = this.props.homepageModal ? { position: "relative" } : undefined

    return <div className="modal-background" onClick={() => this.props.changeParentState({ modalOpen: false })}>
      <div style={scrollWrapperStyle}>
      <div className={modalClass} onClick={e => e.stopPropagation()} ref={this.modalContentRef}>
        <div className="orderPreviewModalComponent">
          {modal}
          <div className="photographerModalHeading">
            <div className="photographerModalDescription">Availability for {photographer.firstName}</div>
            <div className="signupFormPrevious" style={{ cursor: 'pointer' }} onClick={() => this.props.changeParentState({ contractorCalendarOpen: false })}>Close</div>
          </div> 
          <div className="photographerSubheading photographerSubheadingTop">Below you will find the available dates and
            times for the selected photographer.
          </div>
          <div className="mainSchedulingComponentGroup">
            <div className="dateSelectionGrouping">
              <div className="timeslotCard">
                <div className="photographerCardHeader" id="contractorCardHeader">
                  <div className="d-flex justify-content-between">
                    <UserAvatar user={photographer} />
                    <div className="photographerCardInfo">
                      <div className="photographerCardName">{photographer.firstName || photographer.first_name}  {photographer?.lastName ? photographer?.lastName[0] : false || photographer?.last_name ? photographer?.last_name[0] : false}</div>
                      {this.state.isLargeScreen ? <div>
                        <a className="photographerCardButton" href={`/photographers/${photographer.id}`}
                          target="_blank">
                          <i className="far fa-user-circle" />
                          Profile
                        </a>
                      </div> : ""}
                    </div>
                  </div>
                </div>
              </div>
              <div className="contractorTimeSlotDateHeadingGroup">
                <div className="contractorTimeSlotsHeading">
                  <div className="selectedWeekday">
                    {this.state.selected ? formatDatetime(this.state.selected, "dddd") : ''},
                  </div>
                  <div
                    className="selectedMonth">{this.state.selected ? formatDatetime(this.state.selected, "MMMM") : ''} </div>
                  <div className="selectedDate">{this.state.selected ? formatDatetime(this.state.selected, "DD") + ', ' : ''}</div>
                  <div className="selectedDate">{this.state.selected ? formatDatetime(this.state.selected, "YYYY") : ''}</div>
                </div>
                <div className="selectedArrows">
                  <div onClick={this.subtractMonth} className="selectedArrowLeft"><i className="fas fa-chevron-left"></i>
                  </div>
                  <div className="selectedArrowMonth">{this.state.month.toLocaleString('default', { month: 'long' })}</div>
                  <div onClick={this.addMonth} className="selectedArrowRight"><i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </div>
              <div className="daysGroupDiv">
                <div className="contractorTimeSlotsDates">
                  {fillerDays}
                  {dates}
                </div>
              </div>
            </div>
            <div className="timeSlotGrouping">
              <div className="selectTime">Select time</div>
              <div className="small mb-3">
                Times are shown in {this.props.detected_timezone || this.props.client_timezone || this.props.project?.client?.timezone || this.props.currentUser?.timezone}
              </div>
              <div className="timesDiv">
                {times.length > 0 ? times : <div className="noTimeslotsDiv">No timeslots for this date</div>}
              </div>
            </div>
          </div>
        </div>
        <div className="modalMobilePushup"></div>
      </div>
      {this.props.homepageModal && <ScrollArrows scrollRef={this.modalContentRef} />}
      </div>
    </div>
  }
}

export default withRouter(ContractorCalendar)